<template>
  <div class="form">
    <!--     <v-dialog v-model="dialog" max-width="600px" persistent> -->

    <v-card>
      <v-card color="primary" flat>
        <v-card-title>
          <span class="headline white--text">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn class="ma-0 pa-0" color="white black--text " @click="close">
            Close
          </v-btn>
        </v-card-title>
      </v-card>
      <v-card-text>
        <v-card flat class="pr-3 scroll">
          <v-form>
            <!-- {{getSchema.bn_name}} -->
            <v-text-field
              name="Title"
              label="Bangla Name"
              v-model="getSchema.bn_name"
              :rules="nameRules"
            ></v-text-field>
            <v-text-field
              name="Title"
              label="English Name"
              v-model="getSchema.en_name"
              :rules="nameRules"
            ></v-text-field>
            <!-- -->
            <v-autocomplete
              name="Title"
              :item-text="item => item.en_name"
              item-value="thana_code"
              v-model="getSchema.thana_code"
              :items="getThanaItem"
              label="Thana Name"
            >
            <template v-slot:selection="data">
              <v-chip
                color="grey lighten-4"
                :selected="data.selected"
              >
                <span class="subheading">{{
                  data.item.en_name
                }}</span>
              </v-chip>
            </template>
          </v-autocomplete>
            <!-- -->

            <v-text-field
              name="Title"
              label="post_office_code"
              v-model="getSchema.post_office_code"
              :rules="generalRules"
            ></v-text-field>
          </v-form>
        </v-card>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-layout justify-space-between>
          <v-btn color="error  black--text m-1" @click="clear">Reset</v-btn>
          <span></span>
          <v-btn
            color="primary  white--text"
            @click.stop.prevent="validationForm()"
            >{{ buttonTitle }}</v-btn
          >
        </v-layout>
      </v-card-actions>
    </v-card>
    <!--     </v-dialog> -->
  </div>
</template>

<script>
export default {
  // $_veeValidate: {
  //   validator: "new",
  // },
  components: {},
  props: ["dialogStatus", "editedData", "indexEdited"],
  data: () => ({
    // getSchema: {},
    loading: false,
    dialog: false,
    nameRules: [(v) => !!v || "Field is required"],
    generalRules: [
      (v) => !!v || "Field is required",
      (v) => /^\d*$/.test(v) || "Enter number only",
    ],
  }),
  created() {
    this.$store.dispatch("callThanaData");
  },
  mounted() {},
  watch: {
    dialogStatus(val) {
      this.dialog = val;
      this.$store.commit("SET_POST_OFFICE_SCHEMA", this.editedData);
    },
    dialog(val) {
      if (!val) this.close();
    },
  },
  computed: {
    getThanaItem() {
      return this.$store.getters.getThanaItem;
    },
    getSchema() {
      return this.$store.getters.getPostOfficeSchema;
    },

    buttonTitle() {
      return this.indexEdited === -1 ? "Save" : "Update";
    },
    formTitle() {
      return this.indexEdited === -1
        ? "Create New Post Office"
        : "Edit Post Office ";
    },
  },
  methods: {
    async save() {
      let self = this;

      let item = await this.getSchema;
      await this.$store
        .dispatch("savePostOfficeData", item)
        .then(function (data) {
          try {
            self.close();
            self.$store.dispatch("callPostOfficeData");
            //self.$store.dispatch("fetchCenLsDistToRegData");
          } catch (ex) {
            //  console.log(ex);
          }
        })
        .catch(function () {
          //  console.log();
        });
      this.$emit("saveText", 1);
    },
    async edit() {
      let self = this;
      let item = await this.getSchema;
      await this.$store
        .dispatch("editPostOfficeData", item)
        .then(function (data) {
          self.close();
          self.$emit("update:loadData", true);
          self.$store.dispatch("callPostOfficeData");
        })
        .catch(function (error) {
          //  console.log(error);
          //self.$store.dispatch("fetchCenLsDistToRegData");
        });
      this.$emit("saveText", -1);
    },

    close() {
      this.$emit("update:dialogStatus", false);
      setTimeout(() => {
        this.$emit("update:indexEdited", -1);
      }, 300);
      this.clear();
    },

    validationForm() {
      // this.$validator.validateAll().then((isValid) => {
      // if (isValid) {
      return this.indexEdited === -1 ? this.save() : this.edit();
      // }
      // });
    },
    clear() {
      // this.$store.commit("SET_DISTRICT_SCHEMA");
      this.getSchema.bn_name = "";
      this.getSchema.en_name = "";
      this.getSchema.thana_code = "";
      this.getSchema.post_office_code = "";
    },
  },
};
</script>

<style scoped>
.scroll {
  overflow-y: auto;
}
@media (min-width: 576px) {
  .form-card-size {
    max-width: 5px;
    /* width: 500px; */
  }
}
@media (min-width: 768px) {
  .form-card-size {
    max-width: 60px;
  }
}

@media (min-width: 992px) {
  .form-card-size {
    max-width: 120px;
  }
}

@media (min-width: 1200px) {
  .form-card-size {
    max-width: 300px;
  }
}
</style>
